"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1AircrewDataMock = exports.AFTO781V1AircrewDataFlightConditionsMock = exports.AFTO781V1AircrewDataFlightConditionsCombatSptMock = exports.AFTO781V1AircrewDataFlightConditionsCombatMock = exports.AFTO781V1AircrewDataFlightTimeMock = exports.AFTO781V1AircrewDataFlightTimeTotalsMock = void 0;
const uuid_1 = require("uuid");
const afto_781_v1_aircrew_data_model_1 = require("./afto_781_v1-aircrew-data.model");
class AFTO781V1AircrewDataFlightTimeTotalsMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewDataFlightTimeTotals {
    constructor(data) {
        const seedData = {
            time: 3.2,
            srty: 1.5,
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataFlightTimeTotalsMock = AFTO781V1AircrewDataFlightTimeTotalsMock;
class AFTO781V1AircrewDataFlightTimeMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewDataFlightTime {
    constructor(data) {
        const seedData = {
            prim: 2.3,
            sec: 0.5,
            instr: 0.8,
            eval: 0.4,
            totals: new AFTO781V1AircrewDataFlightTimeTotalsMock(),
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataFlightTimeMock = AFTO781V1AircrewDataFlightTimeMock;
class AFTO781V1AircrewDataFlightConditionsCombatMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewDataFlightConditionsCombat {
    constructor(data) {
        const seedData = {
            time: 1.2,
            srty: 0.7,
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataFlightConditionsCombatMock = AFTO781V1AircrewDataFlightConditionsCombatMock;
class AFTO781V1AircrewDataFlightConditionsCombatSptMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewDataFlightConditionsCombatSpt {
    constructor(data) {
        const seedData = {
            time: 0.9,
            srty: 0.5,
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataFlightConditionsCombatSptMock = AFTO781V1AircrewDataFlightConditionsCombatSptMock;
class AFTO781V1AircrewDataFlightConditionsMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewDataFlightConditions {
    constructor(data) {
        const seedData = {
            night: 1.4,
            ins: 0.8,
            simIns: 1.2,
            nvg: 0.6,
            combat: new AFTO781V1AircrewDataFlightConditionsCombatMock(),
            combatSpt: new AFTO781V1AircrewDataFlightConditionsCombatSptMock(),
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataFlightConditionsMock = AFTO781V1AircrewDataFlightConditionsMock;
class AFTO781V1AircrewDataMock extends afto_781_v1_aircrew_data_model_1.AFTO781V1AircrewData {
    constructor(data) {
        const seedData = {
            userId: (0, uuid_1.v4)(),
            flightTime: new AFTO781V1AircrewDataFlightTimeMock(),
            flightConditions: new AFTO781V1AircrewDataFlightConditionsMock(),
        };
        super(seedData);
    }
}
exports.AFTO781V1AircrewDataMock = AFTO781V1AircrewDataMock;
